import axios from 'axios';
import { Message } from 'element-ui';
import app from '../main';
import authen from '../utils/authen';
import router from '@/router';

axios.defaults.baseURL = process.env.BASE_URI;
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['Accept'] = 'application/json';

var temp = 0;

axios.interceptors.request.use(
  config => {
    authen.checkIsAuthenticated(valid => {
      if (valid) {
        let token = authen.getToken();
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        let role = authen.get('qlmn_role');
        router.push({
          name: role === 'admin' ? 'admin-login' : 'user-login'
        });
      }
    });
    // config progressbar start
    temp === 0 && app.$Progress.start();
    temp++;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    // config progressbar finish
    temp--;
    temp === 0 && app.$Progress.finish();

    const res = response.data;
    return res;
  },
  error => {
    temp--;
    temp === 0 && app.$Progress.fail();
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);



// WEBPACK FOOTER //
// ./src/utils/axios.js